import {PickupPoint} from "./pickup-point";

export class ZasilkovnaPickupPoint extends PickupPoint {

	get_api_key() {
		return zasilkovna_widget_params.zasilkovna_api_key
	}

	callback = (location_data) => {
		if (location_data != null && typeof location_data !== "undefined") {
			this.set_address({
				'pickup_point_id': location_data.id,
				'company_name': location_data.place,
				'address_line_1': location_data.street,
				'city': location_data.city,
				'zip': location_data.zip
			})
		}
	}

	open_pickup() {

		let language = zasilkovna_widget_params.language
		let country = jQuery("select[name='shipping_country']").val().toLowerCase()

		Packeta.Widget.pick(
			this.get_api_key(),
			this.callback,
			{
				"country": country,
				"language": language
			}
		)
	}

}
